module.exports = __webpack_public_path__ + "static/media/historie_img.676c26f0.jpg";